import type { InternationalAlpha2 } from './locations'

// #region special values recognized by react-phone-number-input
export const INTERNATIONAL_CODE: InternationalAlpha2 = 'ZZ'

export const INTERNATIONAL_VALUE = undefined

export const LocationOptions = {
  DIVIDER: '|',
  INTERNATIONAL: '🌐',
} as const
// #endregion

export const DEFAULT_LOCATION_NAME = 'phoneNumberLocation'
